"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizeAgentSheet = CustomizeAgentSheet;
var _react = require("react");
var _customizeAgent = require("@design-generated/customize-agent");
var _customizeAgent2 = require("@design-generated/customize-agent.wiring");
var _select = require("@design/ui/select");
var _textarea = require("@design/ui/textarea");
var _ModelSelectionDropdown = require("../../ModelSelectionDropdown");
var _useAgentSettings2 = require("../use-agent-settings");
var _importedBottomSheet = require("./imported-bottom-sheet");
var _iconButtonActivation = require("../../confirmation-dialog/icon-button-activation");
var _scrollBoxStyles = require("../../../scroll-boxes/scroll-box-styles");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AGENT_NAME_INPUT_ID = "customize-agent-name";
var AGENT_INSTRUCTIONS_INPUT_ID = "customize-agent-instructions";
var AGENT_MODEL_SELECT_ID = "customize-agent-model";
function CustomizeAgentSheet(_ref) {
  var onClose = _ref.onClose,
    model = _ref.model,
    onSaved = _ref.onSaved;
  var _useAgentSettings = (0, _useAgentSettings2.useAgentSettings)(true),
    agentName = _useAgentSettings.agentName,
    setAgentName = _useAgentSettings.setAgentName,
    instructions = _useAgentSettings.instructions,
    setInstructions = _useAgentSettings.setInstructions,
    isFormDisabled = _useAgentSettings.isFormDisabled,
    errorMessage = _useAgentSettings.errorMessage,
    saveAgentSettings = _useAgentSettings.saveAgentSettings;
  var _useState = (0, _react.useState)(model.value),
    _useState2 = _slicedToArray(_useState, 2),
    draftModel = _useState2[0],
    setDraftModel = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    agentNameLabel = _useState4[0],
    setAgentNameLabel = _useState4[1];
  var formScrollArea = agentNameLabel && (0, _scrollBoxStyles.nearestScrollContainer)(agentNameLabel);
  var _useScrollDown = (0, _importedBottomSheet.useScrollDown)(formScrollArea),
    hasMoreBelow = _useScrollDown.hasMoreBelow,
    scrollDown = _useScrollDown.scrollDown;
  function handleSave() {
    return _handleSave.apply(this, arguments);
  }
  function _handleSave() {
    _handleSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return saveAgentSettings();
          case 1:
            if (_context.v) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            if (draftModel !== model.value) model.onChange(draftModel);
            _context.n = 3;
            return onSaved();
          case 3:
            onClose();
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleSave.apply(this, arguments);
  }
  var errorNotice = errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-sm text-destructive",
    children: errorMessage
  }) : null;
  var modelSelect = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
      value: draftModel,
      onValueChange: setDraftModel,
      disabled: isFormDisabled,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
        id: AGENT_MODEL_SELECT_ID,
        className: "h-10 w-full",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
        children: _ModelSelectionDropdown.MODEL_OPTIONS.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
            value: option.value,
            children: option.label
          }, option.value);
        })
      })]
    }), errorNotice]
  });
  var instructionsInput = /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
    id: AGENT_INSTRUCTIONS_INPUT_ID,
    rows: 1,
    className: "min-h-10 w-full",
    value: instructions,
    placeholder: "e.g. always respond to me in French",
    disabled: isFormDisabled,
    onChange: function onChange(event) {
      return setInstructions(event.target.value);
    }
  });
  var wiring = {
    close: (0, _iconButtonActivation.closeIconButton)(onClose),
    label: {
      htmlFor: AGENT_NAME_INPUT_ID,
      ref: setAgentNameLabel
    },
    input: {
      id: AGENT_NAME_INPUT_ID,
      value: agentName,
      disabled: isFormDisabled,
      onChange: function onChange(event) {
        return setAgentName(event.target.value);
      }
    },
    label2: {
      htmlFor: AGENT_INSTRUCTIONS_INPUT_ID
    },
    fieldSlot2: instructionsInput,
    label3: {
      htmlFor: AGENT_MODEL_SELECT_ID
    },
    fieldSlot3: modelSelect,
    button: {
      onClick: onClose
    },
    button2: {
      disabled: isFormDisabled,
      onClick: handleSave
    },
    kbd: {},
    kbd2: {},
    customizeAgentShowScroller: hasMoreBelow,
    button3: {
      "aria-label": "Scroll down",
      onClick: scrollDown
    },
    iconCaretDown: {}
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_importedBottomSheet.ImportedBottomSheet, {
    onClose: onClose,
    title: "Customize Agent",
    "data-sentry-element": "ImportedBottomSheet",
    "data-sentry-component": "CustomizeAgentSheet",
    "data-sentry-source-file": "customize-agent-sheet.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_customizeAgent2.CustomizeAgentContext.Provider, {
      value: wiring,
      "data-sentry-element": "CustomizeAgentContext.Provider",
      "data-sentry-source-file": "customize-agent-sheet.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_customizeAgent.CustomizeAgentScreen, {
        "data-sentry-element": "CustomizeAgentScreen",
        "data-sentry-source-file": "customize-agent-sheet.tsx"
      })
    })
  });
}